// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3K9H-","content":"GlobalSearch_content__FUip-"};